var SVG = require("svg.js");

var MapRegion = require("./mapRegion");

var HerefordshireMap = function() {
    var self = this;

    var $currentContext = $();
    var classMap = {};

    var moduleOptions = {
        viewBox: {
            width: 800,
            heigth: 940
        },
        animate: false,
        mapPath: "",
        regions: {
            mouseOutColor: "#9ebc5f",
            mouseOverColor: "#339f97"
        }
    };
    
    var _regionModels = [];
    
    var paper;
    var _regions = [];

    var loadMap = () => {
        if (!moduleOptions.mapPath) return;

        $.ajax({
            url: moduleOptions.mapPath,
            type: "GET",
            dataType: "text",
            success: mountMap,
            error: console.error
        });
    };

    var mountMap = (map) => {
        paper = SVG("svg-herefordshire-map").svg(map);

        initRegions();
        setViewBox();
    };

    var initRegions = () => {
        _regions = _regionModels.map((r) => {
            var region = new MapRegion(paper, r, {
                animate: moduleOptions.animate,
                fillOut: moduleOptions.regions.mouseOutColor,
                fillOver: moduleOptions.regions.mouseOverColor
            });

            return region;
        });
    };
 
    var setViewBox = () => {
        paper.viewbox(0, 0, moduleOptions.viewBox.width, moduleOptions.viewBox.heigth);
    };

    this.regions = function () {
        return _regions;
    };

    this.on = (event, callback) => {
        events.push({name: event, callback: callback})
    };

    this.init = function($context, options, regionModels) {
        $.extend(moduleOptions, options);
        $currentContext = $context || $currentContext;
        _regionModels = regionModels;
        
        loadMap();
    };

    Object.seal(self);
    
    return this;
};

module.exports = HerefordshireMap;